import { QueryClient } from "@tanstack/react-query";

// One client for the whole app. Defaults tuned for a marketplace where most
// data changes on the order of minutes — instant render from cache on tab
// revisit, quiet background refetch keeps it fresh.
//
// Per-query overrides:
//   - Hot data (orders, payouts):       staleTime ~30s
//   - Cold data (store profile):        staleTime ~5min
//   - Realtime-driven (chat thread):    no useQuery — managed by realtime channel
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});
